import React from 'react';
import SafeImage from '../../../../elements/SafeImage';
import stylesheet from './EventHeaderImage.module.scss';

const EventHeaderImage = props => {
    const {event} = props;

    return <SafeImage className={stylesheet.EventHeaderImage} src={event.logo_url} />;
};

export default EventHeaderImage;
